import { Link } from 'react-router-dom';
import { formatDate } from '@/hooks/useFavorites';
import { typeLabels, type Movie } from '@/mocks/movies';

interface LatestUpdatesProps {
  movies: Movie[];
}

export default function LatestUpdates({ movies }: LatestUpdatesProps) {
  return (
    <section className="w-full px-4 md:px-8 mt-12 md:mt-16">
      <div className="flex items-end justify-between gap-4 mb-5">
        <div>
          <div className="flex items-center gap-2">
            <span className="w-1.5 h-5 rounded-full bg-primary-500"></span>
            <h2 className="font-heading text-xl md:text-2xl font-black text-foreground-950">
              最新更新
            </h2>
          </div>
          <p className="mt-1.5 text-xs md:text-sm text-foreground-500">
            按上线时间倒序排列，第一时间追上刚更新的内容
          </p>
        </div>
        <Link
          to="/search"
          className="text-xs md:text-sm text-foreground-600 hover:text-primary-600 flex items-center gap-1 whitespace-nowrap"
        >
          全部搜索
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>

      <div className="rounded-lg border border-background-200 bg-background-50 overflow-hidden">
        {movies.map((movie, i) => (
          <Link
            key={movie.id}
            to={`/detail/${movie.id}`}
            className={`group flex items-center gap-3 md:gap-5 px-3 md:px-5 py-3 hover:bg-background-100 transition-colors ${
              i !== 0 ? 'border-t border-background-200' : ''
            }`}
          >
            <span className="hidden sm:block w-6 text-center font-label text-xs font-bold text-foreground-400">
              {String(i + 1).padStart(2, '0')}
            </span>
            <div className="w-14 md:w-16 aspect-[5/7] rounded-md overflow-hidden bg-background-200 shrink-0">
              <img
                src={movie.poster}
                alt={`${movie.title} 封面`}
                title={`${movie.title} - ${typeLabels[movie.type]}`}
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="min-w-0 flex-1">
              <div className="flex items-center gap-2 flex-wrap">
                <h3 className="font-heading text-sm md:text-base font-bold text-foreground-950 truncate group-hover:text-primary-600 transition-colors">
                  {movie.title}
                </h3>
                <span className="px-1.5 py-0.5 rounded bg-primary-50 text-primary-700 text-[10px] whitespace-nowrap">
                  {typeLabels[movie.type]}
                </span>
              </div>
              <p className="mt-1 text-[11px] md:text-xs text-foreground-500 truncate">
                {movie.year} · {movie.region} · {movie.genres.join(' / ')}
              </p>
              <p className="hidden sm:block mt-0.5 text-[11px] md:text-xs text-foreground-500 truncate">
                导演 {movie.director} · 主演 {movie.cast.join(' / ')}
              </p>
            </div>
            <div className="text-right shrink-0 flex flex-col items-end gap-1">
              <span className="font-label text-xs md:text-sm font-bold text-primary-600">
                {movie.rating.toFixed(1)}
              </span>
              <span className="text-[10px] md:text-xs text-foreground-400 whitespace-nowrap">
                {formatDate(movie.updatedAt)}
              </span>
              <span className="hidden md:inline text-[10px] text-foreground-500 whitespace-nowrap">
                {movie.status}
              </span>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}